import React, { useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import { Col, Container, Row } from 'react-bootstrap'
import { Box, InnerHeading, LazyImage, MainHeading, SpanStyled, SpanStyledB } from '../../../ui/Elements'
import { ArrowBtnBrown, CEO, CEOBg, CEOImg, Sofa, TransformBg } from '../../../ui/AllImages'
import { useTranslation } from 'react-i18next'
import { ContactButton } from '../../../ui/CustomElements'
import i18n from '../../../Languages/INEXT'
import { Animate } from 'react-simple-animate'

const CeoMessage = () => {
    const { t } = useTranslation();
    const sectionRef = useRef(null);
                  const [isVisible, setIsVisible] = useState(false);
            useEffect(() => {
                    const observer = new IntersectionObserver(
                      ([entry]) => {
                        // When visible, set to true
                        if (entry.isIntersecting) {
                          setIsVisible(true);
                          observer.disconnect(); // run animation once
                        }
                      },
                      {
                        threshold: 0.2, // 20% of section visible triggers the animation
                      }
                    );
                
                    if (sectionRef.current) {
                      observer.observe(sectionRef.current);
                    }
                
                    return () => observer.disconnect();
                  }, []);
                    const start = { opacity: 0, transform: 'translateY(-40px)' };
                    const end = { opacity: 1, transform: 'translateY(0)' };
                    const start2 = { opacity: 0, transform: 'translateY(100px)' };
                    const end2 = { opacity: 1, transform: 'translateY(0)' };
    return (
        <>
            <CEOWrapper className='container-fluid common-space ceoFluid' ref={sectionRef}>
                <Container>
                    <Row className='ceoRow row'>
                        <Col md={12} className="ceoColMain">
                            <Box className='ceoContent'>
                                <Box className='ceoImg'>
                                    <LazyImage src={CEO} />
                                </Box>
                                <Animate
                                    play={isVisible}
                                    duration={1}
                                    delay={.5}
                                    start={start}
                                    end={end}
                                >
                                <InnerHeading className='main-heading inner-heading-ceo mb-1' color="var(--bg2)">
                                    {t('ceoHeading')}
                                </InnerHeading>
                                </Animate>
                                <Animate
                                    play={isVisible}
                                    duration={1}
                                    delay={1}
                                    start={start}
                                    end={end}
                                >
                                <MainHeading className='main-heading main-heading-ceo mb-4' color="var(--secondaryColor)">
                                    {t('ceoName')}
                                </MainHeading>
                                </Animate>
                                <Animate
                                    play={isVisible}
                                    duration={1}
                                    delay={1.5}
                                    start={start}
                                    end={end}
                                >
                                <SpanStyled className='d-flex mb-0 ceoTxt' color="var(--bg2)">
                                    {t('ceoTxt')}
                                </SpanStyled>
                                </Animate>
                                
                            </Box>
                            

                        </Col>
                        
                    </Row>
                </Container>
            </CEOWrapper>
        </>
    )
}
const CEOWrapper = styled.section`
    padding-bottom: 0;
    padding-top: 0;
    
    margin-top: 80px;
    
    & > .container{
        .ceoRow{
            margin-left: 0;
            margin-right: 0;
        }
        .ceoColMain{
            position: relative;
            display: flex;
            align-items: center;
            height: 465px;
            padding-left: 550px;
            padding-right: 35px;
            background-image: url(${CEOBg});
            background-repeat: no-repeat;
            background-size: cover;
            background-position: center;
            
           border-radius: 0 100px 0 100px;
            .ceoContent{
                display: flex;
                /* width: 545px; */
                flex-wrap: wrap;
                flex-direction: column;
                padding-left: 0;
                
            }
            .ceoImg{
                position: absolute;
                left: 80px;
                bottom: 0px;
            }
        }
        
    }
    .inner-heading-ceo{
        font-size: 35px;
    }
    .main-heading-ceo{
        font-size: 45px;
    }
    body.rtl &{
        & > .container{
            
            .ceoColMain{
                padding-right: 550px;
                padding-left: 35px;
                border-radius: 100px 0 100px 0;
                .ceoImg{
                    left: auto;
                    right: 80px;
                }
            }
            
        }
        .main-heading-ceo{
            font-size: 65px;
        }
        .inner-heading-ceo{
            padding-bottom: 0;
        }
        .ceoTxt{
            line-height: 2;
        }
    }
    
    @media (max-width: 1399px) {
        
    }
    @media (max-width: 1299px) {
        .container .ceoColMain .ceoImg {
            left: 30px;
        }
        .container .ceoColMain {
            padding-left: 490px;
        }
        body.rtl &{
            .container .ceoColMain .ceoImg {
                left: auto;
                right: 30px;
            }
            .container .ceoColMain {
                padding-left: 35px;
                padding-right: 490px;
            }
        }
    }
    @media (max-width: 1199px) {
        
    }
    @media (max-width: 991px) {
        margin-top: 0;
        .container .ceoColMain .ceoImg{
            top: -70px;
            left: 0;
            right: 0;
            margin: auto;
            width: 433px;
            height: auto;
            bottom: unset;
        }
        .container .ceoColMain {
            padding-left: 20px;
            padding-right: 20px;
            height: auto;
            padding-top: 500px;
            padding-bottom: 60px;
            border-radius: 0 50px 0 50px;
        }
        .inner-heading-ceo, .main-heading-ceo, .ceoTxt{
            text-align: center;
        }
        body.rtl &{
            
            .container .ceoColMain {
                padding-left: 20px;
                padding-right: 20px;
                border-radius: 50px 0px 50px 0px;
            }
            .main-heading-ceo{
                font-size: 55px;
            }
        }
    }
    @media (max-width: 767px) {
        
    }
    @media (max-width: 640px) {
       
    }
    @media (max-width: 575px) {
        .container .ceoColMain .ceoImg {
            width: 280px;
        }
        .container .ceoColMain {
            padding-top: 320px;
        }
    }
    @media (max-width: 350px) {
        
    }
`
export default CeoMessage
